export default __webpack_public_path__ + "static/media/p10.6458abd9.jpg";